import { OrderStatus } from "@/enums/order";

export const isOrderPaid = (timelines: { status: string }[]): boolean =>
  timelines.some((t) => t.status.toLowerCase() === OrderStatus.PAID);
